import React, { useState } from 'react';
import useWindowSize from '../../hooks/useWindowSize';
import { ThemeProvider } from 'styled-components';

import Chevron from '-!svg-react-loader!../../ui/svgs/icon-chevron.svg';
import Cross from '-!svg-react-loader!../../ui/svgs/icon-cross.svg';
import OImage from '../OImage';
import YouTube from '../YouTube';
import Wrapper from '../../ui/Wrappers';
import { BREAKPOINTS } from '../../ui/settings';
import { themes } from '../../ui/design-tokens';
import { Module, Container, Item, VrContainer, Visualizer } from './styles';
import { getSrcset } from '../../ui/helpers';
import Play from '-!svg-react-loader!../../ui/svgs/play-button.svg';

interface IItem {
  key?: string;
  type: string;
  description?: string;
  itemUrl?: any;
  itemAlt?: string;
  itemThumbnail?: any;
}

interface IProps {
  theme?: string;
  heading?: string;
  title?: string;
  items: Array<IItem>;
  vr?: string;
}

const Gallery = ({ theme, heading, title, items, vr }: IProps) => {
  const vpSize = useWindowSize();
  const [zoom, setZoom] = useState(null);
  const [interactive, setInteractive] = useState(true);
  const cleanedTheme = theme ? theme : 'white';

  // Nueva función para detectar si vr contiene HTML
  const isHtml = (str: string) => /<[^>]+>/.test(str);

  return (
    <ThemeProvider theme={themes.basic[cleanedTheme]}>
      <Module>
        <Wrapper size="reader">
          {title &&
            (heading === 'heading_2' ? (
              <h2 className="title">{title}</h2>
            ) : (
              <h3 className="title">{title}</h3>
            ))}
        </Wrapper>
        <Wrapper size="mainwrapper" as={Container}>
          {items.map((item, i) => {
            return (
              <Item key={item.key} data-gtm-action="galeria" data-gtm-category="interaccion">
                <div className="top">
                  {item.type === 'image' ? (
                    <OImage
                      src={item.itemUrl.original?.href}
                      aspectRatio={
                        item.itemUrl.original?.meta.width / item.itemUrl.original?.meta.height
                      }
                      alt={item.itemAlt || ''}
                      srcSet={getSrcset(item.itemUrl, false, ['xxsmall, xsmall, small'])}
                      webp={getSrcset(item.itemUrl, true, ['xxsmall, xsmall, small'])}
                      className={`top_image ${
                        vpSize.width >= BREAKPOINTS.medium ? 'top_clickable' : ''
                      }`}
                      onClick={() => (vpSize.width >= BREAKPOINTS.medium ? setZoom(i) : null)}
                      data-gtm-event
                      data-gtm-label={'imagen_' + item.itemUrl.original?.href}
                    />
                  ) : vpSize.width < BREAKPOINTS.medium ? (
                    <>
                      {zoom !== i && (
                        <>
                          <div className="icon" onClick={() => setZoom(i)}>
                            <Play className="svg" />
                          </div>
                          <OImage
                            aspectRatio={16 / 9}
                            alt={item.itemAlt || ''}
                            className="top_image top_clickable"
                            bg={item.itemThumbnail.original?.href}
                            onClick={() => setZoom(i)}
                            data-gtm-event
                            data-gtm-label={'video_' + item.itemUrl.original?.href}
                          />
                        </>
                      )}
                      {zoom !== null && zoom === i && (
                        <YouTube
                          className={'image'}
                          videoUrl={items[zoom].itemUrl}
                          aspectRatio={16 / 9}
                          lazy={false}
                          delay={0}
                        />
                      )}
                    </>
                  ) : (
                    <>
                      <div className={'icon'} onClick={() => setZoom(i)}>
                        <Play className="svg" />
                      </div>
                      <OImage
                        aspectRatio={16 / 9}
                        alt={item.itemAlt || ''}
                        className="top_image top_clickable"
                        bg={item.itemThumbnail.original?.href}
                        onClick={() => setZoom(i)}
                        data-gtm-event
                        data-gtm-label={'video_' + item.itemUrl.original?.href}
                      />
                    </>
                  )}
                </div>
                {item.description && <div className="bottom">{item.description}</div>}
              </Item>
            );
          })}
          {vr && (
            isHtml(vr) ? (
              <VrContainer ratio={16 / 9}>
                <div
                  className={`overlay ${interactive ? '' : 'interactive'}`}
                  onClick={() => setInteractive(false)}></div>
                <div className="vr" dangerouslySetInnerHTML={{ __html: vr }} />
              </VrContainer>
            ) : (
              <div className="vr-text">{vr}</div>
            )
          )}
        </Wrapper>
        {vpSize.width >= BREAKPOINTS.medium && zoom !== null && (
          <Visualizer>
            <div className="main">
              <div
                className="main_circle"
                onClick={() => (zoom > 0 ? setZoom(zoom - 1) : setZoom(items.length - 1))}>
                <Chevron className="svg" />
              </div>
              <div className="main_middle">
                {items[zoom].type === 'image' ? (
                  <OImage
                    src={items[zoom].itemUrl.original?.href}
                    aspectRatio={
                      items[zoom].itemUrl.original?.meta.width /
                      items[zoom].itemUrl.original?.meta.height
                    }
                    alt={items[zoom].itemAlt || ''}
                    srcSet={getSrcset(items[zoom].itemUrl)}
                    webp={getSrcset(items[zoom].itemUrl, true)}
                    className="image"
                    lazy={false}
                  />
                ) : (
                  <YouTube
                    className={'image'}
                    videoUrl={items[zoom].itemUrl}
                    aspectRatio={16 / 9}
                    lazy={false}
                    delay={0}
                  />
                )}

                <div className="close" onClick={() => setZoom(null)}>
                  <Cross className="svg cross" />
                </div>
              </div>

              <div
                className="main_circle"
                onClick={() => (zoom < items.length - 1 ? setZoom(zoom + 1) : setZoom(0))}>
                <Chevron className="svg right" />
              </div>
            </div>
          </Visualizer>
        )}
      </Module>
    </ThemeProvider>
  );
};

export default Gallery;
